export const getItem = (state) => {
    const result = state.item;
    return result;
}